import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ManageUserRoleWidget from '../../../../widgets/manageUserRole/ManageUserRoleWidget'
import ManageEvaluationTeamRoleWidget from '../../../../widgets/manageUserRole/ManageEvaluationTeamRoleWidget'
import { getManageUserEvaluateRoleGroup } from '../../../../redux/actions/manageAccess'

export default function ManageEvaluationTeamRole() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  const mockSchema = {
    header: 'จัดการสิทธิ์ทีมประเมินผล',
    // subHeader: 'โครงการ 65-00012-01 : เด็กฉลาด ขอเบิกงวดเงิน',
    subHeader: '',
    form: {
      title: 'จัดการสิทธ์',
      projectCode: {
        label: 'รหัสโครงการ',
        name: 'projectCode',
        value: null,
      },
      values: [
        {
          projectVersion: '1111-1111-1111-111',
          projectCode: '67-10007',
          projectName: 'โครงการ AA',
          projectStatus: '1111-1111-1111-111',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: 'นายสมพงษ์ รักสงบ',
          granteeName: 'นาย B',
        },
        {
          projectVersion: '1111-1111-1111-111',
          projectCode: '67-10007',
          projectName: 'โครงการ AA',
          projectStatus: '1111-1111-1111-111',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: 'นายสงบ เอี่ยมสุข',
          granteeName: 'นาย B',
        },
        {
          projectVersion: '3333-3333-3333-333',
          projectCode: '67-10009',
          projectName: 'โครงการ AAAAA',
          projectStatus: '3333-3333-3333-333',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: null,
          granteeName: 'นาย B',
        },
      ],
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageUserEvaluateRoleGroup('', 10, 1)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectReport>
        <ContentHeader header={schema.header2} subHeader={schema.subHeader} />

        {/* <ManageUserRoleWidget schema={schema.form} /> */}
        <ManageEvaluationTeamRoleWidget schema={schema.form} />
      </SidebarProposal>
    </>
  )
}
